export const isIE = window.navigator.userAgent.indexOf('Trident/') > -1;
